module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Dedication")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("To Barney…")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Thanks for the hot meals when we would have had cold cuts the days I was glued to the computer!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23ab6361","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section4.vue
// module id = 69
// module chunks = 0